import { Box, MenuItem } from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import styled from '@mui/material/styles/styled';

export const StyledFormSection = styled(Box)(() => ({
  padding: '0 20px',
}));

export const StyledBrightness1Icon = (color: string) => (
  <Brightness1Icon
    sx={{
      color,
      mr: 1,
      fontSize: '0.8rem',
    }}
  />
);

const colors = [
  { value: '#5FC8F1', label: 'Blue' },
  { value: '#dd7ddd', label: 'Violet' },
  { value: '#E8C12A', label: 'Yellow' },
  { value: '#72D4B4', label: 'Green' },
  { value: '#B589F0', label: 'Purple' },
];

export const colorOptions = colors.map((color) => (
  <MenuItem
    key={color.value}
    value={color.value}
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    {StyledBrightness1Icon(color.value)}
    {color.label}
  </MenuItem>
));
